import { Humanize, capitalizeText } from "../../helpers";

export default function DisplayPrivilegesText({ privileges = [] }) {
  return privileges
    .map((privilege) => {
      return capitalizeText(Humanize(privilege));
    })
    .join(", ");
}
